import { LogoutButton } from '~domains/profile/shared/ui';

import { ScreenHeader, ScreenHeaderProps } from '~shared/ui/screen';

export const PersonFormHeader = (props: ScreenHeaderProps) => {
  return <ScreenHeader {...props} rightSlot={<LogoutButton />} />;
};
